"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAssignAgentToEnquiryResponseDataDto = instanceOfAssignAgentToEnquiryResponseDataDto;
exports.AssignAgentToEnquiryResponseDataDtoFromJSON = AssignAgentToEnquiryResponseDataDtoFromJSON;
exports.AssignAgentToEnquiryResponseDataDtoFromJSONTyped = AssignAgentToEnquiryResponseDataDtoFromJSONTyped;
exports.AssignAgentToEnquiryResponseDataDtoToJSON = AssignAgentToEnquiryResponseDataDtoToJSON;
exports.AssignAgentToEnquiryResponseDataDtoToJSONTyped = AssignAgentToEnquiryResponseDataDtoToJSONTyped;
/**
 * Check if a given object implements the AssignAgentToEnquiryResponseDataDto interface.
 */
function instanceOfAssignAgentToEnquiryResponseDataDto(value) {
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('receiverId' in value) || value['receiverId'] === undefined)
        return false;
    return true;
}
function AssignAgentToEnquiryResponseDataDtoFromJSON(json) {
    return AssignAgentToEnquiryResponseDataDtoFromJSONTyped(json, false);
}
function AssignAgentToEnquiryResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'enquiryId': json['enquiryId'],
        'receiverId': json['receiverId'],
    };
}
function AssignAgentToEnquiryResponseDataDtoToJSON(json) {
    return AssignAgentToEnquiryResponseDataDtoToJSONTyped(json, false);
}
function AssignAgentToEnquiryResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'enquiryId': value['enquiryId'],
        'receiverId': value['receiverId'],
    };
}
